import { render, staticRenderFns } from "./banksetPopupCNPJ.vue?vue&type=template&id=4cfcd143&scoped=true"
import script from "./banksetPopupCNPJ.vue?vue&type=script&lang=js"
export * from "./banksetPopupCNPJ.vue?vue&type=script&lang=js"
import style0 from "./banksetPopupCNPJ.vue?vue&type=style&index=0&id=4cfcd143&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfcd143",
  null
  
)

export default component.exports